import SelectBox from "@/components/common/SelectBox";
import Input from "@/components/common/Input";
import {buildSearchQuery, makeQueryString, setToast} from "@/utils";
import {IoCloseCircle, IoSearch} from "react-icons/io5";
import {SearchWrapper, SearchWrapper02} from "@/styles/CommonStyle";
import React from "react";
import {observer} from "mobx-react";

const GAP_CONFIRM = "공백만으로 검색 불가 합니다.";
const STRING_CONFIRM = "검색어 입력후 검색해주세요.";


export const SearchWrapArea = observer(({
            store,
            flatParam,
            selectList = [],
            menuId,
            pathname,
            router,
            type
        }) => {
    const Wrapper = type === "admin" ? SearchWrapper02 : SearchWrapper;
    return (
        <Wrapper>
            <div className={"search-content"}>
                <div className={"select-type"}>
                    <SelectBox
                        id={"career-filter"}
                        option={selectList}
                        size="l"
                        type="solid"
                        round={true}
                        placeholder="선택"
                        onChange={(e) => {
                            const selected = e.value;
                            store.searchBaseStore.setUpdatedParams("searchType", selected);
                            store.searchBaseStore.setUpdatedParams("searchString", "");
                        }}
                        hover={false}
                        value={selectList.find((opt) => opt.value === store.searchBaseStore.searchParams.searchType) || selectList[0]}
                    />
                </div>
                <div className={"search-area"}>
                    <Input
                        inputType="text"
                        placeholder="입력해주세요"
                        width={"fill"}
                        value={store.searchBaseStore.searchParams.searchString}
                        onChange={(e) => {
                            store.searchBaseStore.setUpdatedParams(
                                "searchString",
                                e.target.value
                            );
                        }}
                        onKeyDown={async (e) => {
                            if (e.key === "Enter") {
                                await setDraw(
                                    store,
                                    menuId,
                                    0,
                                    undefined,
                                    false,
                                    false,
                                    pathname,
                                    router,
                                    type
                                );
                            }
                        }}
                    />
                    {store.searchBaseStore.searchParams.searchString &&
                    store.searchBaseStore.searchParams.searchType &&
                    flatParam.searchString &&
                    flatParam.searchType &&
                    store.searchBaseStore.searchParams.searchString === flatParam.searchString &&
                    store.searchBaseStore.searchParams.searchType === flatParam.searchType ? (
                        <div
                            className={"close-btn"}
                            onClick={async () => {
                                await setDraw(
                                    store,
                                    menuId,
                                    undefined,
                                    undefined,
                                    true,
                                    false,
                                    pathname,
                                    router,
                                    type
                                );
                            }}
                        >
                            <IoCloseCircle color={"#999999"} size={24} />
                        </div>
                    ) : (
                        <div
                            className={"search-btn"}
                            onClick={async () => {
                                await setDraw(
                                    store,
                                    menuId,
                                    0,
                                    undefined,
                                    false,
                                    false,
                                    pathname,
                                    router,
                                    type
                                );
                            }}
                        >
                            <IoSearch color={"#999999"} size={24} />
                        </div>
                    )}
                </div>
            </div>
        </Wrapper>
    );
})




export const setDraw = async (
        store,
        menuId,
        offset,
        limit,
        clear = false,
        paging = false,
        pathname,
        router,
        type
    ) => {
    if (clear) {
        const clearParamMap = {
            "menu-id": menuId,
            searchType: "",
            searchString: "",
            offset: 0,
        };
        if(type === "admin"){
            clearParamMap["limit"] = store.currentBoardContent.options.limit;
        } else {
            clearParamMap["limit"] = store.currentMenu.options.limit;
        }
        store.clearParams(clearParamMap);
    } else {
        if(!paging){
            if (!store.searchBaseStore.searchParams.searchType) {
                store.searchBaseStore.searchParams.searchType = "title";
            }
            if (store.searchBaseStore.searchParams.searchString) {
                if (/^ *$/.test(store.searchBaseStore.searchParams.searchString)) {
                    if(type === "admin"){
                        setToast("warning", GAP_CONFIRM);
                    } else {
                        alert(GAP_CONFIRM);
                    }
                    return;
                }
            } else {
                if(type === "admin"){
                    setToast("warning", STRING_CONFIRM);
                } else {
                    alert(STRING_CONFIRM);
                }
                return;
            }
        }
    }

    if (typeof offset === "number") {
        store.searchBaseStore.setUpdatedParams("offset", offset);
    }
    if (limit) {
        store.searchBaseStore.setUpdatedParams("limit", limit);
    }
    store.searchBaseStore.setDeleteCheckedTypeMap("boardListRow");
    const queryObject = buildSearchQuery(store.searchBaseStore.searchParams);
    const params = makeQueryString(queryObject);
    router.replace(`${pathname}${params}`, { scroll: false });
    if(type === "admin"){
        await store.setFetchBoardList(params);
    }else {
        await store.getFetchBoard(params);
    }
}